import React from 'react';

import RichTextElement from '../../Elements/RichText';

import { SectionMapProps, ImageKeys } from './types/SectionMap.types';
import {
  MapOuterContainer,
  MapInnerContainer,
  MapTextContainer,
  MapDesktopImageContainer,
  MapTabletImageContainer,
  MapMobileImageContainer,
} from './styles/SectionMap.styles';

const SectionMap: React.FC<SectionMapProps> = ({
  content,
  responsiveImageCollection,
}) => {
  const images = responsiveImageCollection
    ? responsiveImageCollection.map(respImage => {
        const container: Record<ImageKeys, any> = {};

        container['source'] = respImage.imageTitle.file.url;
        container['maxWidth'] = respImage.maxWidth;
        container['secondImageSource'] =
          respImage.secondImage?.file?.url ?? null;
        container['mobileImageSource'] =
          respImage.mobileBackgroundImage?.file?.url ?? null;

        return container;
      })
    : [];

  images.sort((a, b) => (b.maxWidth > a.maxWidth && 1) || -1);

  const desktopImageSrc = images.reduce((acc, css, idx) => {
    return css.source;
  }, '');

  const tabletImageSrc = images.reduce((acc, css, idx) => {
    return css.secondImageSource;
  }, '');

  const mobileImageSrc = images.reduce((acc, css, idx) => {
    return css.mobileImageSource;
  }, '');

  const theContent = content?.map(item => {
    return (
      <RichTextElement
        key={item.id}
        rawRichText={item.text.raw}
        color={item.color}
        textAlign={item.textAlign}
      />
    );
  });

  let bgAltText = '';

  return (
    <MapOuterContainer>
      <MapInnerContainer>
        <MapTextContainer>{theContent}</MapTextContainer>
        <MapDesktopImageContainer>
          <img src={desktopImageSrc + '?fm=webp'} alt="desktop map image" />
        </MapDesktopImageContainer>
        <MapTabletImageContainer>
          <img src={tabletImageSrc + '?fm=webp'} alt="tablet map image" />
        </MapTabletImageContainer>
        <MapMobileImageContainer>
          <img src={mobileImageSrc + '?fm=webp'} alt="mobile map image" />
        </MapMobileImageContainer>
      </MapInnerContainer>
    </MapOuterContainer>
  );
};

export default SectionMap;
